<template>
  <div class="privacy-tab">
    <section class="section">
      <div class="container">
        <header class="head reveal">
          <h1>隐私政策</h1>
          <p>更新日期：2026年4月27日</p>
          <p>生效日期：2026年4月27日</p>
        </header>

        <article class="card reveal">
          <h2>1. 适用范围</h2>
          <p>
            本隐私政策适用于中鸿云智（浙江）科技有限公司（以下简称“我们”）通过本网站提供的信息展示、咨询沟通及相关服务。
          </p>

          <h2>2. 我们收集的信息</h2>
          <p>在您使用“在线咨询/提交申请”等功能时，我们可能收集以下信息：</p>
          <ul>
            <li>基础身份信息：姓名。</li>
            <li>联系方式：手机号、邮箱等。</li>
            <li>业务信息：所属行业/单位、咨询内容、需求描述。</li>
            <li>访问信息：设备类型、浏览器信息、访问时间、页面操作日志。</li>
          </ul>

          <h2>3. 信息使用目的</h2>
          <ul>
            <li>与您联系并响应咨询、演示申请、合作沟通。</li>
            <li>评估与优化我们的产品、服务质量和用户体验。</li>
            <li>保障网站与服务安全，防范违规或异常行为。</li>
            <li>履行法律法规规定的义务。</li>
          </ul>

          <h2>4. 信息共享与披露</h2>
          <p>我们不会向无关第三方出售您的个人信息。在以下情形中可能共享或披露：</p>
          <ul>
            <li>经您明确授权或同意。</li>
            <li>为实现服务目的，向受我们委托并签署保密义务的合作方提供必要信息。</li>
            <li>根据法律法规、司法机关或行政机关要求进行披露。</li>
          </ul>

          <h2>5. 信息存储与保护</h2>
          <ul>
            <li>我们采取合理的管理和技术措施保护您的信息安全。</li>
            <li>仅在实现本政策目的所需的最短期限内保留相关信息，法律法规另有规定的除外。</li>
            <li>如发生安全事件，我们将依法及时告知您并采取补救措施。</li>
          </ul>

          <h2>6. 您的权利</h2>
          <p>您有权依法对个人信息进行查询、更正、删除，或撤回授权同意。您可通过本政策“联系我们”所示方式与我们联系。</p>

          <h2>7. Cookie 与同类技术</h2>
          <p>
            为保障网站基础功能与统计分析，我们可能使用 Cookie 或同类技术。您可通过浏览器设置进行管理，但可能影响部分功能体验。
          </p>

          <h2>8. 未成年人保护</h2>
          <p>本网站主要面向企业及机构客户。若您为未成年人，请在监护人指导下使用本网站并提交信息。</p>

          <h2>9. 政策更新</h2>
          <p>我们可能根据业务和法规要求更新本政策，更新后将在本页面发布并注明更新时间。</p>

          <h2>10. 联系我们</h2>
          <p>如您对本政策有任何疑问、意见或投诉，可通过以下方式联系我们：</p>
          <ul>
            <li>公司名称：中鸿云智（浙江）科技有限公司</li>
            <li>联系电话：0571-28113599</li>
            <li>联系邮箱：1637227159@qq.com</li>
            <li>联系地址：浙江省杭州市拱墅区蓝天商务中心1202室</li>
          </ul>
        </article>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyTab'
}
</script>

<style scoped lang="less">
.container {
  width: min(980px, calc(100% - 48px));
  margin: 0 auto;
}

.section {
  padding: 56px 0 24px;
}

.head h1 {
  margin: 0;
  font-size: clamp(32px, 3.8vw, 46px);
  color: #132e57;
}

.head p {
  margin: 8px 0 0;
  color: #637b99;
}

.card {
  margin-top: 22px;
  border: 1px solid #dfe8f8;
  border-radius: 18px;
  padding: 24px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(18, 48, 97, 0.08);
}

.card h2 {
  margin: 18px 0 10px;
  color: #183966;
  font-size: 22px;
}

.card h2:first-child {
  margin-top: 0;
}

.card p,
.card li {
  color: #546d8a;
  line-height: 1.9;
}

.card ul {
  margin: 8px 0 0;
  padding-left: 22px;
}

@media (max-width: 768px) {
  .container {
    width: min(980px, calc(100% - 24px));
  }

  .card {
    padding: 18px;
  }

  .card h2 {
    font-size: 18px;
  }

  .card p,
  .card li {
    font-size: 14px;
  }
}
</style>
